// extracted by mini-css-extract-plugin
export default {"tag":"Tag__tag___fNcmm","disabled":"Tag__disabled___ri1He","nowrap":"Tag__nowrap___ULPjg"};